import { useSyncExternalStore } from "react";

let logoutInFlight = false;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) {
    listener();
  }
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function beginLogoutInFlight() {
  logoutInFlight = true;
  emit();
}

export function cancelLogoutInFlight() {
  logoutInFlight = false;
  emit();
}

export function isLogoutInFlight() {
  return logoutInFlight;
}

export function useLogoutInFlight() {
  return useSyncExternalStore(subscribe, isLogoutInFlight, isLogoutInFlight);
}
